/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle, IconButton,
  styled,
  Typography
} from '@material-ui/core';
// import { Field, FieldArray, reduxForm } from 'redux-form';
// import CustomDropDownArray from '../../../../utils/redux-forms-custom-fields/CustomDropDownArray';
import CloseIcon from "@material-ui/icons/Close";
import { Elements } from "@stripe/react-stripe-js";
import StripeCDKCheckoutForm from "./StripeCDKCheckoutForm";
import { loadStripe } from "@stripe/stripe-js";

import PromptDialog from "../dialog/PromptDialog";

import { isPrerender, safeLoadThirdParty } from '../../utils/prerender';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiTypography-h6': {
    width: '100%'
  },
}));
let stripeKey = process.env.NODE_ENV === 'production' ? process.env.STRIPE_SECRET_KEY : process.env.NODE_ENV === 'staging' ? process.env.STRIPE_SECRET_KEY_STAGING : "pk_test_51QEmxyFV4wQHDaQmgDo69oUK5es4zGq7jvcKz7JEeJbOqOwYHDqzmcSO1YjDOkadgtUJAjGuHtHU3Y9MP7DM2d0r00oATrNgOj";
if (process.env.NODE_ENV === 'production') {
  stripeKey = "pk_live_51REgDpI6JENQgpzjwRokyE8RLxp5GbY1S4ojEEy1WUIO2W19yi57AukHbrsiqGKan8yig09PtxvYIZUTdRF3Ekwm00UaMPdxJS";
} else {
  stripeKey = "pk_test_51QEmxyFV4wQHDaQmgDo69oUK5es4zGq7jvcKz7JEeJbOqOwYHDqzmcSO1YjDOkadgtUJAjGuHtHU3Y9MP7DM2d0r00oATrNgOj";
}

// Initialize stripePromise only in a real browser runtime and not during prerendering.
let stripePromise = null;
if (typeof window !== 'undefined' && !isPrerender()) {
  // safeLoadThirdParty will call the initializer and return its result; for loadStripe that is a Promise
  stripePromise = safeLoadThirdParty(() => loadStripe(stripeKey, { betas: ['captcha_challenge_beta_1'] }));
}

class StripeDialog extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      open: props.open,
      isProcessingStripe: false,
      payErrorType: 1,
      dialogResultOpen: false,
      errorText: '',
      sendEmail: ''
    };
  }
  componentDidMount() {
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  handleResultClose = () => {
    this.setState({
      dialogResultOpen: false,
      payErrorType: 1,
      errorText: ''
    });

  }

  handleError = (error) => {
    console.error("Stripe Payment or Order Confirmation Error1:", error);

    // 使用已导入的getDetailedErrorMessage函数
    const errorText = error.message || (error.error && error.error.message) || '支付处理过程中出现错误，请重试';

    // 设置为更友好的错误信息，而不仅仅是默认消息
    this.setState({
      isProcessingStripe: false,
      dialogResultOpen: true,
      payErrorType: -1, // 支付失败
      errorText: errorText // 存储格式化的错误消息供显示使用
    });
  }

  handleSuccess = (orderData) => {
    console.log("Stripe Payment and Order Confirmation Success in GameNew:", orderData);

    // 准备显示成功信息
    this.setState({
      open: false, // 关闭Stripe弹窗
      dialogResultOpen: true,   // 打开结果弹窗
      payErrorType: 1,          // 设置为成功类型
      sendEmail: orderData.sendEmail,
      //orderDeliveryStatus: orderData.deliveryStatus || 'pending',
      //isProcessingStripe: false
    });
  }

  render() {
    const { onClose, order } = this.props;
    const { payErrorType, dialogResultOpen } = this.state;
    const { user, token: authToken } = this.props.auth;

    return (
      <section className="Game">
        <BootstrapDialog
          open={this.state.open}
          onClose=""
          aria-labelledby="stripe-payment-dialog-title"
          maxWidth="md"
          fullWidth
          disableBackdropClick={this.state.isProcessingStripe}
          disableEscapeKeyDown={this.state.isProcessingStripe}
          PaperProps={{
            style: {
              backgroundColor: '#322d38',
              color: '#fff',
              borderRadius: '12px',
              overflow: 'hidden'
            },
          }}
        >
          <DialogTitle
            id="stripe-payment-dialog-title"
            sx={{ width: '100%' }}
            style={{
              borderBottom: '1px solid #3a3643',
              padding: '20px 24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <Box display="flex" justifyContent="space-between" width="100%">
              <div>
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>secure payment</Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ fontSize: '14px', marginRight: '10px', color: '#cdccd0' }}>By</span>
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo,_revised_2016.svg"
                    alt="Stripe"
                    style={{ height: '20px' }}
                  />
                  <span style={{ fontSize: '14px', marginLeft: '10px', color: '#cdccd0' }}>Provide secure payment</span>
                </div>
              </div>
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
                style={{ float: 'right' }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent style={{ padding: '0' }}>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '400px' }}>
              {this.state.open && (
                <Elements stripe={stripePromise}>
                  <StripeCDKCheckoutForm
                    purchaseMethod={'stripe'}
                    onSuccess={this.handleSuccess}
                    onError={this.handleError}
                    authToken={authToken}
                    onClose={onClose}
                    order={order}
                    user={user}
                    setProcessingState={(isProcessing) => this.setState({ isProcessingStripe: isProcessing })}
                    onRequiresAction={() => { // 新增的回调处理
                      console.log("Payment requires additional verification step.");
                      // 可选：在这里更新 GameNew 组件的状态以显示提示信息
                      //this.setState({ showScaNotification: true });
                    }}
                  />
                </Elements>
              )}
            </div>
          </DialogContent>

        </BootstrapDialog>
        {payErrorType === -1 && dialogResultOpen && <PromptDialog
          dialogOpen={dialogResultOpen}
          level="failure"
          title="<span style='color: #f44336; font-size: 20px; font-weight: bold'>Payment Failed</span>"
          content={`
            <div style="text-align: center; padding: 10px 15px">
              <div style="margin-bottom: 15px; font-size: 16px; color: #f44336;">
                <span style="font-weight: 500">There was a problem with your payment</span>
              </div>
              <div style="margin-bottom: 15px; font-size: 15px; line-height: 1.5">
                ${this.state.errorText}
              </div>
              <div style="font-size: 14px; color: #757575; font-style: italic; padding: 0 20px">
                Please try again with another payment method or contact support if the problem persists.
              </div>
            </div>
          `}
          cancelAction={this.handleResultClose}
          cancelButtonName="Close"
        />}
        {payErrorType === 1 && dialogResultOpen && <PromptDialog
          dialogOpen={dialogResultOpen}
          level="success"
          title="<span style='color: #4caf50; font-size: 24px; font-weight: bold'>Payment successful!</span>"
          content={`
            <div style="text-align: center; padding: 10px 15px">
              <div style="margin-bottom: 15px; font-size: 16px">
                <span style="font-weight: 500">Thank you for your purchase!</span>
              </div>
              <div style="margin-bottom: 15px; font-size: 15px; line-height: 1.5">
                Your CDKey will be sent to <span style="color: #2196f3; font-weight: 500">${this.state.sendEmail}</span> shortly.
              </div>
              <div style="font-size: 14px; color: #757575; font-style: italic; padding: 0 20px">
                Please note that some payments may require additional verification before delivery.
              </div>
            </div>`}
          cancelAction={onClose}
          cancelButtonName="Close"
        />}
      </section>
    );
  }
}

StripeDialog.propTypes = {

};

export default StripeDialog;
